module.exports = __webpack_public_path__ + "7fc613aa32db9b0e37135cb29fae858d.ttf";